import { AppPage } from "models/AppPage";
import { useRouter } from "next/router";
import { useState } from "react";

interface UseNavigationStateReturn {
    activeDropdown: string | null;
    setActiveDropdown: (label: string | null) => void;
    currentTag: string | undefined;
    isOnTagRoute: boolean;
    isPageActive: (page: AppPage) => boolean;
}

/**
 * Custom hook to manage navigation state and active page detection
 * Centralizes dropdown state and routing logic
 */
export const useNavigationState = (
    pages: AppPage[]
): UseNavigationStateReturn => {
    const router = useRouter();
    const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

    // Check if current route has a tag query parameter
    const currentTag = router.query.tag as string | undefined;
    const isOnTagRoute = !!currentTag;

    /**
     * Determine if a page is currently active based on pathname and tag route
     * Special handling for "콘텐츠 큐레이션" to avoid activation on tag routes
     */
    const isPageActive = (page: AppPage): boolean => {
        if (
            page.label === "콘텐츠 큐레이션" &&
            router.pathname === "/" &&
            !isOnTagRoute
        ) {
            return false;
        }
        return page.active(router.pathname);
    };

    return {
        activeDropdown,
        setActiveDropdown,
        currentTag,
        isOnTagRoute,
        isPageActive
    };
};
